import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import VueI18n from 'vue-i18n'
import es from './translate/es'
import en from './translate/en'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import LazyYoutubeVideo from 'vue-lazy-youtube-video'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import vueHeadful from 'vue-headful'
import VueAnalytics from 'vue-analytics'
import VCurrencyField from 'v-currency-field'
import VueRx from 'vue-rx'

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-111188380-3',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

axios.defaults.baseURL = 'https://us-central1-trartist-com.cloudfunctions.net/api/'
axios.defaults.headers.post['Content-Type'] = 'application/json'

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 0,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: false
})

Vue.use(VueI18n)
Vue.use(VueRx)
Vue.use(VueTheMask)
Vue.component('Youtube', LazyYoutubeVideo)
Vue.component('vueHeadful', vueHeadful)
Vue.use(VueReCaptcha, { siteKey: '6Lecxt8UAAAAANdBSDw6vkeCkYV-cwWQnueVDhNB' })

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    es,
    en
  }
})
export default i18n

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mounted () {
    moment.locale('es')
  },
  render: h => h(App)
}).$mount('#app')
